module.exports = __webpack_public_path__ + "img/6c7e60d.png";